import { gql } from '@efficiently/client-core-graphql-models';

export const GENERATE_FONTS_ASSETS_SIGNED_COOKIES = gql(`
	query GenerateFontsAssetsSignedCookiesAccess {
		fontsAssetsSignedCookiesAccess {
			accessSetterUrl
		}
	}
`);
